define.alias("shared/components/shared/modal/navigation", "preview-grid/components/shared/modal/navigation");